<template>
  <v-container class="pb-0">
    <v-row>
      <v-col>
        <v-container py-0>
          <v-row justify="end">
            <v-btn
              color="primary"
              @click="onAddNotesClick"
              :disabled="$store.getters.hasAccessTo('suppliers:view_only')"
            >
              <v-icon left>mdi-plus-circle</v-icon>Add Service Notes
            </v-btn>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-data-table
            :items="items"
            :headers="headers"
            :loading="$apollo.loading"
          >
            <template v-slot:item.dateFrom="{ item }">{{
              item.dateFrom | formatDate
            }}</template>
            <template v-slot:item.dateTo="{ item }">{{
              item.dateTo | formatDate
            }}</template>
            <template v-slot:item.actions="{ item }">
              <default-list-actions
                :item="item"
                hide-view
                @deleteItem="onDeleteItem"
                @editItem="onEditItem"
                :hide-remove="$store.getters.hasAccessTo('suppliers:view_only')"
                :hide-edit="$store.getters.hasAccessTo('suppliers:view_only')"
              ></default-list-actions>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <service-notes-edit-dialog
      :show="showItemEditor"
      @close="showItemEditor = false"
      :services="services"
      v-model="editedItem"
      @input="onSaveItem"
    />
    <code v-if="debug"> {{ services }} </code>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
import ServiceNotesEditDialog from "./ServiceNotesEditDialog.vue";
const LIST_QUERY = gql`
  query supplierServiceNotes($id: ID) {
    serviceNotes(id: $id) {
      edges {
        node {
          id
          groupId
          agentGroupName
          dateFrom
          dateTo
          description
          department
          groupId
          services
          serviceNames
        }
      }
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createServiceNote($input: ServiceNoteInput!) {
    createServiceNote(input: $input) {
      id
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateServiceNote($input: ServiceNoteInput!) {
    updateServiceNote(input: $input) {
      id
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteServiceNote($id: ID!) {
    deleteServiceNote(id: $id) {
      id
    }
  }
`;
export default {
  name: "service-notes",

  props: {
    supplierId: {
      type: String,
      default: () => "",
    },
    services: {
      type: Array,
      default: () => [],
    },
  },

  components: { DefaultListActions, ServiceNotesEditDialog },

  data: () => ({
    debug: false,
    showItemEditor: false,
    editedItem: null,
    headers: [
      {
        text: "From",
        value: "dateFrom",
        name: "dateFrom",
      },
      {
        text: "To",
        value: "dateTo",
        name: "dateTo",
      },
      {
        text: "Description",
        value: "description",
        name: "description",
      },
      {
        text: "Services",
        value: "serviceNames",
        name: "serviceNames",
      },
      {
        text: "Department",
        value: "department",
        name: "department",
      },
      {
        text: "Agent/Group",
        value: "agentGroupName",
        name: "agentGroupName",
      },
      {
        text: "Actions",
        value: "actions",
        name: "actions",
      },
    ],
  }),

  computed: {
    items() {
      return this.serviceNotes && this.serviceNotes.edges
        ? this.serviceNotes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onAddNotesClick() {
      this.editedItem = null;
      this.showItemEditor = true;
    },

    onEditItem(payload) {
      this.editedItem = { ...payload };
      this.showItemEditor = true;
    },
    onSaveItem(payload) {
      this.showItemEditor = false;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input: { ...payload, supplierId: this.supplierId } },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: { id: this.supplierId },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Service Note Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: { id: this.supplierId },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Service Note Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    serviceNotes: {
      query: LIST_QUERY,
      variables() {
        return { id: this.supplierId };
      },
      skip() {
        return this.supplierId == "";
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/service-notes/ServiceNotes.vue